export const flowActiveZH = {
  flowActive1: '我报名了',
  flowActive2: '，正在召集队员，邀请你和我一起参加！',
  flowActive3: '报名时间',
  flowActive4: '待定',
  flowActive5: '内容专区',
  flowActive6: '活动任务',
  flowActive7: '报名已结束',
  flowActive8: '立即报名',
  flowActive9: '即将开始',
  flowActive10: '即刻开启社会化学习，成就自我，塑造未来',
  flowActive11: '立即报名',
  flowActive12: '查看活动详情',
  flowActive13: '更多现场照片',
  flowActive14: '了解详情',
  flowActive15: '您的浏览器不支持 video 标签。',
  flowActive16: '我的活动',
  flowActive17: '认证中心',
  flowActive18: '有趣活动中还没发现你的身影?！',
  flowActive19: '去解锁新体验',
  flowActive20: '进度',
  flowActive21: '活动任务',
  flowActive22: '总体进度',
  flowActive23: '未解锁',
  flowActive24: '进行中',
  flowActive25: '已结束',
  flowActive26: '阶段进度',
  flowActive27: '已为你筛选出当前可完成的任务，先努力完成这些吧',
  flowActive28: '进度飞快，当前进行中的任务已全部完成',
  flowActive29: '查看全部任务',
  flowActive30: '距离截止还有',
  flowActive31: '前完成',
  flowActive32: '后可查看任务详情哦~',
  flowActive33: '立即缴费',
  flowActive34: '算了，先逛逛',
  flowActive35: '知道了',
  flowActive36: '完成其中任意一个任务后，才可查看此任务哦',
  flowActive37: '完成',
  flowActive38: '任务后，才可查看此任务哦',
  flowActive39: '暂无数据',
  flowActive40: '请输入姓名',
  flowActive41: '重新生成证书成功！',
  flowActive42: '任务进度',
  flowActive43: '开始学习',
  flowActive44: '您还没有登录，请登录后查看“我的活动”',
  flowActive45: '更多讨论…',
  flowActive46: '天',
  flowActive47: '',
  flowActive48: '展开更多'
}

export const flowActiveEN = {
  flowActive1: `I've registered for `,
  flowActive2: ' and am currently forming a team. I invite you to join me!',
  flowActive3: 'Registration Period',
  flowActive4: 'To Be Announced',
  flowActive5: 'Content Zone',
  flowActive6: 'Activity Tasks',
  flowActive7: 'Registration Closed',
  flowActive8: 'Register Now',
  flowActive9: 'Starting Soon',
  flowActive10: 'Start Social Learning Now, Achieve Personal Growth, Shape Your Future',
  flowActive11: 'Register Now',
  flowActive12: 'Further Details',
  flowActive13: 'More Photos',
  flowActive14: 'Learn More',
  flowActive15: 'Your browser does not support the video tag.',
  flowActive16: 'My Activities',
  flowActive17: 'Authentication Center',
  flowActive18: `Haven't spotted you yet in a fun activity?!`,
  flowActive19: 'To unlock new experiences',
  flowActive20: 'Progress',
  flowActive21: 'Activity Tasks',
  flowActive22: 'Overall Progress',
  flowActive23: 'Unlocked',
  flowActive24: 'Ongoing',
  flowActive25: 'Ended',
  flowActive26: 'Stage Progress',
  flowActive27: `Now that you've been screened out of the tasks that can be completed at the moment, let's try to complete them first`,
  flowActive28: 'Progress is fast, and all the tasks currently in progress have been completed',
  flowActive29: 'View all tasks ',
  flowActive30: ' day(s) to deadline',
  flowActive31: 'Need to becompleted before',
  flowActive32: 'you can view the task details~',
  flowActive33: 'Go now',
  flowActive34: `Later`,
  flowActive35: 'Got it',
  flowActive36: 'You can only view this task after completing any of these tasks',
  flowActive37: 'After completing the ',
  flowActive38: 'task, you can view this task',
  flowActive39: 'No data',
  flowActive40: 'Please enter your name',
  flowActive41: 'Certificate regeneration successful!',
  flowActive42: 'Task progress',
  flowActive43: 'Start learning',
  flowActive44: 'You have not logged in, please check "My activities" after logging in',
  flowActive45: 'More on...',
  flowActive46: '',
  flowActive47: 'After',
  flowActive48: 'View more'
}



// WEBPACK FOOTER //
// ./src/assets/locale/flow/active.js